import _defineProperty from '@babel/runtime/helpers/defineProperty';
import '../../../../../util/styles/index.js';
import { useListBoxSection } from '@react-aria/listbox';
import { mergeProps } from '@react-aria/utils';
import { useSelectionListBoxContext } from '../../../hooks/useSelectionListBoxContext.js';
import { useAdsStyles } from '../../../../../util/styles/hooks/useAdsStyles.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectionListSection = function useSelectionListSection(props) {
  var virtualizedProps = props.virtualizedProps;
  var _useSelectionListBoxC = useSelectionListBoxContext(),
    isVirtualized = _useSelectionListBoxC.isVirtualized;
  var _useReactAriaListBoxS = useListBoxSection(props),
    itemProps = _useReactAriaListBoxS.itemProps,
    groupProps = _useReactAriaListBoxS.groupProps;
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var virtualizerStyle = isVirtualized && virtualizedProps && {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: "".concat(virtualizedProps.size, "px"),
    transform: "translateY(".concat(virtualizedProps.start, "px)")
  };
  var groupStyle = mapAdsStyles(_objectSpread({
    p: '0',
    listStyle: 'none'
  }, isVirtualized && virtualizerStyle));
  return {
    itemProps: itemProps,
    groupProps: mergeProps(groupProps, groupStyle)
  };
};

export { useSelectionListSection };
//# sourceMappingURL=useSelectionListSection.js.map
